export function IconAllProducts({ active }) {
  const stroke = active ? '#f5b400' : 'currentColor'
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 3L20 8V16L12 21L4 16V8L12 3Z" stroke={stroke} strokeWidth="1.8" />
      <path d="M12 8L16 10.5V14.5L12 17L8 14.5V10.5L12 8Z" stroke={stroke} strokeWidth="1.8" />
    </svg>
  )
}

export function IconNonFerrous({ active }) {
  const stroke = active ? '#f5b400' : 'currentColor'
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <ellipse cx="12" cy="14" rx="8" ry="3" stroke={stroke} strokeWidth="1.8" />
      <path d="M4 14C4 10 7.5 7 12 7C16.5 7 20 10 20 14" stroke={stroke} strokeWidth="1.8" />
      <path d="M6 11C8 9 10 8 12 8" stroke={stroke} strokeWidth="1.8" />
    </svg>
  )
}

export function IconFerrous({ active }) {
  const stroke = active ? '#f5b400' : 'currentColor'
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M5 18H19V20H5V18Z" stroke={stroke} strokeWidth="1.8" />
      <path d="M7 18V8H9V18M15 18V8H17V18" stroke={stroke} strokeWidth="1.8" />
      <path d="M9 8H15V10H9V8Z" stroke={stroke} strokeWidth="1.8" />
    </svg>
  )
}

export function IconIndustrial({ active }) {
  const stroke = active ? '#f5b400' : 'currentColor'
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="3" stroke={stroke} strokeWidth="1.8" />
      <path
        d="M12 3V6M12 18V21M3 12H6M18 12H21M5.6 5.6L7.8 7.8M16.2 16.2L18.4 18.4M5.6 18.4L7.8 16.2M16.2 7.8L18.4 5.6"
        stroke={stroke}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function IconRawMaterials({ active }) {
  const stroke = active ? '#f5b400' : 'currentColor'
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M6 16L9 10L12 14L15 8L18 16" stroke={stroke} strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M5 18H19" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  )
}

export function IconScrap({ active }) {
  const stroke = active ? '#f5b400' : 'currentColor'
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M8 8L6 10L8 12M16 8L18 10L16 12M10 6L12 4L14 6M10 18L12 20L14 18M6 14H4M20 14H18M6 10H4M20 10H18"
        stroke={stroke}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path d="M9 12H15C16 14 15 17 12 17C9 17 8 14 9 12Z" stroke={stroke} strokeWidth="1.8" />
    </svg>
  )
}
